import { addClasses } from './addClasses';
import { deferFrames } from './deferFrames';
import { removeClasses } from './removeClasses';
/**
 * Adds classes to an element for a given amount of animation frames.
 *
 * @param n The amount of animation frames to add the classes for.
 * @param classes Rest parameter for one or multiple classes to temporarily add.
 * @param element The element to add the classes to.
 *
 * @example
 *
 * ```typescript
 * declare const element: Element
 * addClassesForNFrames(10, 'class-a', 'class-b') (element)
 * ```
 */
export function addClassesForNFrames(n) {
    var classes = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        classes[_i - 1] = arguments[_i];
    }
    return function (element) {
        addClasses.apply(void 0, classes)(element);
        deferFrames(n, function () { return removeClasses.apply(void 0, classes)(element); });
    };
}
